export function loginUser(state, action) {
  const userLoggedIn = true;

  return {
    ...state,
    userLoggedIn
  };
}

export function logoutUser(state, action) {
  const userLoggedIn = false;

  return {
    ...state,
    userLoggedIn
  };
}



// WEBPACK FOOTER //
// ./src/reducers/user.js